import React from 'react';
const CareerInfo = ({careerContent}) => {
   
    return (
        <div>
            <h5 className="section-title">{careerContent?.title[0]?.text}</h5>
            <div className="row ">
                <div className="col-md-5">  <h3 className="subtitle ">{careerContent?.sub_title[0]?.text}</h3></div>
                <div className="col-md-7 "><p className="body-text career-body-text" >{careerContent?.description[0]?.text}</p></div>
              
                
            </div>
        </div>
    );
};

export default CareerInfo;